import { SharedAppConstants } from '@tock/shared-app-constants';
import { core, toJSONArray } from '@tock/coretypes';

interface State {
  accoladeTypeRatings: core.AccoladeTypeRating[];
  requestInProgress: boolean;
}

const initialState: State = {
  accoladeTypeRatings: [],
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.ACCOLADE_TYPE_RATING_FETCH_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case SharedAppConstants.ACCOLADE_TYPE_RATING_FETCH_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.ACCOLADE_TYPE_RATING_INSERT_DONE:
    case SharedAppConstants.ACCOLADE_TYPE_RATING_FETCH_DONE: {
      return {
        ...state,
        requestInProgress: false,
        accoladeTypeRatings: toJSONArray<core.AccoladeType>(payload),
      };
    }
    default:
      return state;
  }
}
